import apiRoutes from './api.routes';
import ModelService from './model.service';

const WidgetFileService = new ModelService(apiRoutes.widgetsFiles, '/content/widgets', 'content');

WidgetFileService.getImage = (filename, w = false, h = false, c = false) => WidgetFileService.getFilePathByDir('/uploads/widgets', filename, w, h, c);
WidgetFileService.getFile = filename => WidgetFileService.getFilePathByDir('/uploads/widgets', filename);

export default WidgetFileService;



// WEBPACK FOOTER //
// ./src/services/widgetFile.service.js